import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/accessibility")({
  head: () => ({
    meta: [
      { title: "הצהרת נגישות | ישיבת תורת חיים" },
    ],
  }),
  component: AccessibilityPage,
});

function AccessibilityPage() {
  return (
    <section className="container mx-auto px-4 py-16 max-w-3xl" dir="rtl">
      <h1 className="font-display text-4xl font-bold text-primary mb-8">הצהרת נגישות</h1>

      <div className="prose prose-lg space-y-6 text-foreground/80 leading-relaxed">
        <p>
          מוסדות תורת חיים מחויבים להנגשת האתר לאנשים עם מוגבלות, בהתאם לתקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות), התשע"ג-2013, ולתקן הישראלי ת"י 5568 (WCAG 2.0, רמה AA).
        </p>

        <h2 className="font-display text-2xl font-bold text-primary mt-8 mb-3">מה בוצע להנגשת האתר</h2>
        <ul className="list-disc list-inside space-y-2">
          <li>האתר מוגדר בשפה העברית עם כיוון טקסט מימין לשמאל</li>
          <li>ניתן לנווט באתר באמצעות מקלדת בלבד</li>
          <li>כל התמונות כוללות תיאור חלופי (alt text)</li>
          <li>ניגודיות צבעים עומדת בדרישות התקן</li>
          <li>האתר תואם לקוראי מסך נפוצים</li>
          <li>גודל הטקסט ניתן להגדלה ללא אובדן תוכן</li>
        </ul>

        <h2 className="font-display text-2xl font-bold text-primary mt-8 mb-3">פניות בנושא נגישות</h2>
        <p>
          נתקלתם בבעיית נגישות? אנו מזמינים אתכם לפנות אלינו ונשתדל לטפל בבעיה בהקדם האפשרי.
        </p>
        <p>
          <strong>רכז נגישות:</strong> מוסדות תורת חיים
          <br />
          <strong>דוא"ל:</strong>{" "}
          <a href="mailto:toratchaimbb@gmail.com" className="text-primary underline">
            toratchaimbb@gmail.com
          </a>
        </p>

        <h2 className="font-display text-2xl font-bold text-primary mt-8 mb-3">תאריך עדכון ההצהרה</h2>
        <p>הצהרה זו עודכנה לאחרונה בחודש יוני 2026.</p>
      </div>
    </section>
  );
}
